import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import { AppService } from '@app/app.service';
import { Select } from '@app/core/libraries/Dynamic-fields/components/select/classes/Select.class';
import { FuiDestroyService } from '@services/destroy.service';
import { FieldConfig } from '../field.interface';
import { SelectService } from './select-service.service';
import { BehaviorSubject, takeUntil } from 'rxjs';

@Component({
    selector: 'df-app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.scss', '../../../../shared/components/button/styles/button.scss'],
    providers: [SelectService, FuiDestroyService],
})
export class SelectComponent extends Select implements OnInit {
    /**
     * Тултип для самого поля
     */
    public tooltip = new BehaviorSubject<string | null>(null);

    field: FieldConfig;
    group: FormGroup;
    @ViewChild('matSelect', { static: false }) declare matSelect: MatSelect;

    constructor(
        @Inject(FuiDestroyService) protected _destroy$: FuiDestroyService,
        public appService: AppService,
        public service: SelectService,
    ) {
        super(_destroy$, service);
    }

    /** Вызывается один раз после установки свойств компонента */
    ngOnInit(): void {
        super.ngOnInit();
        setTimeout(() => {
            this.matSelect._overlayPanelClass += 'custom-select-panel';
        });

        this.tooltip.next(this.service.getCurrentName());
        this.service.group
            .get(this.service.field.name)
            .valueChanges.pipe(takeUntil(this._destroy$))
            .subscribe(() => {
                this.tooltip.next(this.service.getCurrentName());
            });
    }

    /**
     * Установка опций селекта
     * @param options опции селекта
     */
    setOptions(options) {
        this.field.options = options.slice();
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
        } else {
            this.group.get(this.field.name).enable({ onlySelf: true, emitEvent: false });
        }
    }
}
